/**
 * Represents different types of Customer Contract Payments. This enum extends values from
 */
export enum ContractPaymentTypeModel {
	/**
	 * Represents a Business Development Company (BDC) third party.
	 */
	Bdc = 1,
	/**
	 * Represents an internal third party, typically within the organization.
	 */
	Internal = 2,
	/**
	 * Represents a Group Purchasing Organization (GPO) third party.
	 */
	Gpo = 3,
	/**
	 * Represents a Retention Rates.
	 */
	Rebate = 4
}
